/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 30/10/2020
 */

import * as SessionUtils from '@/core/session_utils.js'

const addToCartRequest = () => {
    return {
        stage_id: 0,
        field_id: 0,
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser()
    }
}

export default addToCartRequest;